import logo from "../assets/images/logo/logo.png";

export { logo };

export const companyDetails = {
  phone: "+91-9451883800",
  email: "aimanashraf@teachelevateai.co.in",
  address: "Plot 13, Gomti Vihar, Kanchanpur, Matiyari, Lucknow, Uttar Pradesh 226028",
  facebook: "",
  twitter: "",
  instagram: "",
  linkedin: "",
};

export const testimonials = [
  {
    id: 1,
    img: require("../assets/images/testimonial/1.jpg"),
    quote: `We approached Tech Elevate to develop a custom e-commerce platform, and we couldn't 
  be more pleased with the results. Their full-stack development team took the time to really 
  understand our vision, and the final product exceeded all of our expectations. The platform is 
  fast, user-friendly, and has had a significant impact on our sales. We are excited to continue 
  working with them on future projects`,
    position: "CEO, Tech Innovators",
    author: "Sruthi M.",
  },
  {
    id: 2,
    img: require("../assets/images/testimonial/2.jpg"),
    quote: `From the start, Tech Elevate impressed us with their ability to turn our mobile app idea 
  into a reality. They took the time to understand our sustainability mission and crafted an app 
  that’s not only functional but also visually appealing. Our users love the app, and we've seen a 
  marked increase in engagement since launch. Working with their team has been a pleasure, and 
  we look forward to more collaborations.`,
    position: "Marketing Director, Green Energy Solutions",
    author: "Rahul K.",
  },
  {
    id: 3,
    img: require("../assets/images/testimonial/3.jpg"),
    quote: `The artificial intelligence solution Tech Elevate developed for our business has been a 
  game-changer. Their machine learning models have automated many of our processes, 
  providing us with deep insights and allowing us to make smarter, data-driven decisions. Their 
  expertise in AI is unparalleled, and we’re already seeing measurable improvements in efficiency 
  and performance.`,
    position: "Founder, HealthTech Innovators",
    author: "Amit Singh",
  },
  {
    id: 4,
    img: require("../assets/images/testimonial/4.jpg"),
    quote: `We turned to Tech Elevate for help with our business intelligence and data analytics needs, 
  and they delivered outstanding results. They helped us transform complex data into actionable 
  insights, allowing us to make more informed decisions. The custom dashboards and real-time 
  reporting tools have been invaluable, helping us stay ahead of the competition and optimize our 
  strategy.`,
    position: "Chief Data Officer, FinCorp Analytics",
    author: "Raveendar S.",
  },
  {
    id: 5,
    img: require("../assets/images/testimonial/5.jpg"),
    quote: `When we needed a mobile app to engage students and enhance their learning experience, 
  Tech Elevate was the perfect partner. The app they developed is intuitive, user-friendly, and 
  works seamlessly on all devices. Our students are more engaged, and we’ve received great 
  feedback about the app’s design and functionality. Their team was incredibly responsive and 
  collaborative throughout the entire project`,
    position: "Co-Founder, EduTech Solutions",
    author: "Siddharth",
  },
];

// faq
export const faqs = [
  {
    id: 1,
    question: "What services does your company offer?",
    answer:
      "We offer a wide range of services including web development, mobile app development, artificial intelligence development, data analytics and business intelligence, and blockchain development.",
  },
  {
    id: 2,
    question: "How does your process ensure success?",
    answer:
      "Our process is designed to ensure precision and efficiency. From discovery and planning to development, testing, and launch, we focus on delivering results that align with your business goals and provide measurable value.",
  },
  {
    id: 3,
    question: "What makes your web development services unique?",
    answer:
      "Our web development services focus on crafting modern, responsive websites and full-stack solutions that enhance online presence and engage audiences effectively.",
  },
  {
    id: 4,
    question: "Can you assist with artificial intelligence development?",
    answer:
      "Yes, we specialize in AI development solutions that help businesses uncover insights, automate processes, and solve complex challenges with precision.",
  },
  {
    id: 5,
    question: "Do you offer mobile app development?",
    answer:
      "Absolutely. Our mobile app development team designs and builds innovative apps that deliver functionality and an exceptional user experience tailored to your audience.",
  },
  {
    id: 6,
    question:
      "What are your data analytics and business intelligence services?",
    answer:
      "Our data analytics and business intelligence services help you make informed decisions by turning raw data into meaningful insights, using data visualization, predictive analytics, and business intelligence strategies.",
  },
  {
    id: 7,
    question:
      "How can your blockchain development services benefit my business?",
    answer:
      "Our blockchain development services provide secure, transparent, and efficient solutions to help modernize processes and create new business opportunities, including smart contracts, decentralized applications, and blockchain supply chain solutions.",
  },
];

// why work with us
export const whyworkwithus = [
  {
    id: 1,
    img: require("../assets/images/why work with us/1.webp"),
    title: "Customized Solutions",
    description:
      "Every project is tailored to your needs, ensuring strategies and results that align with your vision.",
  },
  {
    id: 2,
    img: require("../assets/images/why work with us/2.webp"),
    title: "Expert Professionals",
    description:
      "Our skilled team combines technical expertise with years of experience across industries.",
  },
  {
    id: 3,
    img: require("../assets/images/why work with us/3.webp"),
    title: "Innovative Technologies",
    description:
      "We work with the latest tools and trends to keep your business ahead in the digital race.",
  },
  {
    id: 4,
    img: require("../assets/images/why work with us/4.webp"),
    title: "Client-Focused Approach",
    description:
      "We’re dedicated to understanding your goals and exceeding your expectations every step of the way.",
  },
  {
    id: 5,
    img: require("../assets/images/why work with us/5.webp"),
    title: "Future-Ready Solutions",
    description:
      "We build solutions that evolve with your business needs, ensuring long-term adaptability and success in an ever-changing digital landscape.",
  },
];

// core values
export const coreValues = [
  {
    title: "Pioneering Progress",
    desc: "We are dedicated to breaking boundaries and redefining what is possible. By continuously exploring new ideas and adopting future-ready technologies, we ensure our clients remain at the forefront of innovation while prioritizing secure solutions.",
  },
  {
    title: "Empowerment Through Intelligence",
    desc: "Our solutions are designed to empower businesses with smart, adaptable technologies that evolve with their needs. Security is embedded in every solution to protect our clients' data and operations. We believe in turning complex challenges into intelligent opportunities for growth and success.",
  },
  {
    title: "Integrity and Trust",
    desc: "We build lasting partnerships through honesty, transparency, and ethical practices. Trust is at the core of our business, and we are committed to delivering on our promises with integrity.",
  },
  {
    title: "Adaptability and Agility",
    desc: "In a world of constant change, we remain agile and adaptable. We thrive on tackling new challenges with speed and precision, ensuring that our clients are always prepared for what’s next.",
  },
  {
    title: "Excellence in Execution",
    desc: "We hold ourselves to the highest standards of quality and precision. From concept to delivery, we ensure every solution is meticulously crafted to exceed expectations and deliver lasting with security at its core.",
  },
  {
    title: "Security-First Mindset",
    desc: "We prioritize security in everything we do, ensuring our solutions are built with robust protection mechanisms from the ground up. We maintain vigilance in protecting our clients' digital assets and data, treating security not as an add-on but as a fundamental aspect of all our solutions.",
  },
  {
    title: "Collaboration and Synergy",
    desc: "We believe in the power of collaboration. By fostering strong relationships with clients, partners, and team members, we unlock new possibilities and achieve collective success that drives progress.",
  },
  {
    title: "Future-Forward Vision",
    desc: "We don't just solve today's problems; we anticipate tomorrow's opportunities. Our forward-thinking approach ensures our clients are equipped to shape their future with confidence and security.",
  },
  {
    title: "Sustainable Innovation",
    desc: "We are committed to creating solutions that not only drive business success but also contribute positively to society and the environment. Our innovations aim to build a more sustainable, secure and responsible digital future.",
  },
];

// web development portfolio
export const webDevelopmentPortfolio = [
  {
    id: 1,
    title: "5G Homes",
    image: require("../assets/images/portfolio/web development/5ghomes.webp"),
  },
  {
    id: 2,
    title: "Autopilot",
    image: require("../assets/images/portfolio/web development/Autopilot.png"),
  },
  {
    id: 3,
    title: "Bayut",
    image: require("../assets/images/portfolio/web development/bayut.webp"),
  },
  {
    id: 4,
    title: "Cold Creekcap",
    image: require("../assets/images/portfolio/web development/cold creekcap.webp"),
  },
  {
    id: 5,
    title: "College Nutritionist",
    image: require("../assets/images/portfolio/web development/collegenutritionist.png"),
  },
  {
    id: 6,
    title: "Leadership.net",
    image: require("../assets/images/portfolio/web development/leadership.net.png"),
  },
  {
    id: 7,
    title: "Menissa Caterings",
    image: require("../assets/images/portfolio/web development/menissa caterings.webp"),
  },
  {
    id: 8,
    title: "Think Reality",
    image: require("../assets/images/portfolio/web development/think reality.webp"),
  },
];

// app development portfolio
export const appDevelopmentPortfolio = [
  {
    id: 1,
    title: "Cryptopadie",
    image: require("../assets/images/portfolio/app development/cryptopadie.png"),
  },
  {
    id: 2,
    title: "Doctor Plus",
    image: require("../assets/images/portfolio/app development/doctorplus.png"),
  },
  {
    id: 3,
    title: "Dubai Travel Guide",
    image: require("../assets/images/portfolio/app development/dubai travel guide.webp"),
  },
  {
    id: 4,
    title: "Elora Hair Palour",
    image: require("../assets/images/portfolio/app development/elora hair palour.webp"),
  },
  {
    id: 5,
    title: "Evans Francis",
    image: require("../assets/images/portfolio/app development/evans francis.webp"),
  },
  {
    id: 6,
    title: "House of Deliverance",
    image: require("../assets/images/portfolio/app development/house of deliverance.png"),
  },
  {
    id: 7,
    title: "MyBitsShop",
    image: require("../assets/images/portfolio/app development/mybitsshop.webp"),
  },
  {
    id: 8,
    title: "Namaz",
    image: require("../assets/images/portfolio/app development/namaz.webp"),
  },
  {
    id: 9,
    title: "Potea",
    image: require("../assets/images/portfolio/app development/potea.webp"),
  },
  {
    id: 10,
    title: "Rentop",
    image: require("../assets/images/portfolio/app development/rentop.png"),
  },
];
